/**
 * RISKS-ADMINS.ROUTE.TSX
 */
import NavApp from "@/nav/nav.app"
import RiskAdmins from "@/entities/physical-risk/ui/RiskAdmins"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { useCallback, useEffect } from "react"
import { userFetch, userGet } from "@/redux/user.actions"
import { User } from "@/redux/user.types"

export default function RisksAdminsRoute() {
  const dispatch = useAppDispatch()
  const accountId = useAppSelector((state) => state._session.accountId)
  const settingsExist = useAppSelector((state) => Boolean(state.account.active.accountRisksSettings))

  const loadUsers = useCallback(async () => {
    if (!settingsExist) return

    try {
      const users: any = await dispatch(userFetch("", null, null, [], ""))
      if (users.error) {
        return
      }

      dispatch(userGet(
        users
          .filter((user: User) => user.role === "ADMIN" && !user.EstablishmentId)
          .map((user: User) => new User(user))
      ))
    } catch (error) {
      console.error("Impossible de charger les administrateurs de l'organisation :", error)
    }
  }, [dispatch, accountId, settingsExist])

  useEffect(() => {
    loadUsers()
  }, [loadUsers])

  return (
    <NavApp>
      <RiskAdmins />
    </NavApp>
  )
}
